import api, { ApiResponse } from './api';

export interface SystemSettings {
  event_start_minutes_before: string;
  event_max_retry_minutes: string;
  [key: string]: string;
}

export const systemSettingsService = {
  async get(): Promise<SystemSettings> {
    const response = await api.get<ApiResponse<SystemSettings>>('/system-settings');
    return response.data.data;
  },

  async update(data: Partial<SystemSettings>): Promise<SystemSettings> {
    const response = await api.put<ApiResponse<SystemSettings>>('/system-settings', data);
    return response.data.data;
  },
};
